import {Num, Obj, OptArr, OptStr, Str} from '@shared/api/core/api_schema';

export const WEBSITE_BACKEND_API = {
  '/get-db-urls': {
    POST: {
      req: Obj({current: OptStr()}),
      res: Obj({
        key: Str(),
        parts: OptArr(
          Obj({
            url: Str(),
            startByte: Num(),
            endByte: Num(),
          })
        ),
      }),
    },
  },
};
